import React from 'react';
import RootSidebarLayoutSingleVoyage
    from "@containers/singleVoyage/views/layout/rootSidebar/RootSidebarLayoutSingleVoyage";
import PointsListMutateSingleVoyage
    from "@containers/singleVoyage/mutateVoyage/points/pointsList/PointsListMutateSingleVoyage";
import {
    useViewContextMutateSingleVoyage
} from "@containers/singleVoyage/mutateVoyage/context/viewContext/hooks/useViewContextMutateSingleVoyage";
import HeaderRootSidebarMutateSingleVoyage
    from "@containers/singleVoyage/mutateVoyage/views/rootSidebar/HeaderRootSidebarMutateSingleVoyage";
import {sx} from './sx'

const RootSidebarMutateSingleVoyage = () => {

	const {
		miniModeRootSidebar,
		setMiniModeRootSidebar,
	} = useViewContextMutateSingleVoyage()

	return (
		<RootSidebarLayoutSingleVoyage
			miniMode={miniModeRootSidebar}
			setMiniMode={setMiniModeRootSidebar}
			headerChildren={!miniModeRootSidebar ? <HeaderRootSidebarMutateSingleVoyage/> : undefined}
			sx={sx.sidebar}
		>
			<PointsListMutateSingleVoyage
				miniMode={miniModeRootSidebar}
			/>
		</RootSidebarLayoutSingleVoyage>
	);
};

export default RootSidebarMutateSingleVoyage;